var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"uik-widget-content__wrapper uik-widget-content__grey"},[_c('div',{class:{
        'uik-widget__wrapper':true,
        'uik-widget__padding': _vm.padding
    }},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }